// client/src/pages/user/Tickets.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";
import { Link } from "react-router-dom";

export default function Tickets() {
  const [tickets, setTickets] = useState([]);
  const [status, setStatus] = useState("all");

  useEffect(() => {
    api.get("/user/tickets").then((res) => setTickets(res.data || []));
  }, []);

  const filtered =
    status === "all"
      ? tickets
      : tickets.filter((t) => t.status === status);

  return (
    <div className="space-y-6">
      <h1 className="text-xl font-semibold">Support Tickets</h1>

      <select
        className="input-glass max-w-xs bg-[#0b0f17] text-white"
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="all">All</option>
        <option value="open">Open</option>
        <option value="closed">Closed</option>
      </select>

      {filtered.map((t) => (
        <div key={t._id} className="card-glass p-4">
          <div className="flex justify-between">
            <div>
              <p className="font-semibold">{t.subject}</p>
              <p className="text-xs text-gray-400">
                {new Date(t.createdAt).toLocaleString()}
              </p>
            </div>
            <span className={`chip chip-${t.status}`}>
              {t.status}
            </span>
          </div>

          <Link
            to={`/tickets/${t._id}`}
            className="text-purple-400 text-sm"
          >
            View conversation →
          </Link>
        </div>
      ))}
    </div>
  );
}
